import ResetPasswordForm from '../components/forms/auth/reset-password-form';

const ResetPassword = () => (<ResetPasswordForm/>);
  
export default ResetPassword;